import { faCaretLeft, faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { createElement } from "react";
import DatePicker from "react-datepicker";
import { Button } from "./styles";

import { CustomButton } from "./CustomButton";

import { Props } from "./interfaces";
import { Container } from "./styles";

const FilterByYearAndMonth = ({
  year,
  month,
  handleChangeYearAndMonth,
  filterColor,
  withMaxDate = true,
  disabled = false,
}: Props) => {
  const currDate = new Date();
  const maxDate = new Date(currDate.getFullYear() + 1, 11, 31);
  const maxYear = maxDate.getFullYear();

  return (
    <Container>
      <Button
        onClick={() => handleChangeYearAndMonth("decrease")}
        filterColor={filterColor}
        style={{ minWidth: "unset" }}
        disabled={disabled}
      >
        <FontAwesomeIcon icon={faCaretLeft} />
      </Button>
      <DatePicker
        selected={new Date(year, month, 1)}
        onChange={(date: Date) => handleChangeYearAndMonth("default", date)}
        customInput={createElement(CustomButton)}
        showMonthYearPicker
        dateFormat="MM/yyyy"
        maxDate={withMaxDate ? maxDate : null}
        disabled={disabled}
      />
      <Button
        onClick={() => handleChangeYearAndMonth("increase")}
        disabled={(year >= maxYear && month === 11) || disabled}
        filterColor={filterColor}
        style={{ minWidth: "unset" }}
      >
        <FontAwesomeIcon icon={faCaretRight} />
      </Button>
    </Container>
  );
};

export default FilterByYearAndMonth;
